import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background: transparent;\n  border: 0;\n  display: inline-block;\n  line-height: 1;\n  margin: 0;\n  padding: 0;\n  opacity: ', ';\n  outline: 0;\n'], ['\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background: transparent;\n  border: 0;\n  display: inline-block;\n  line-height: 1;\n  margin: 0;\n  padding: 0;\n  opacity: ', ';\n  outline: 0;\n']);

import styled from 'styled-components';

var EditButton = styled.button(_templateObject, function (props) {
  return props.fieldBaseWrapperIsHover ? '1' : '0';
});

EditButton.displayName = 'EditButton';

export default EditButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/inline-edit/dist/esm/styled/EditButton.js
// module id = 5974
// module chunks = 0